module.exports = __webpack_public_path__ + "img/ad4.09f5c17f.png";